import Body, { BodyProps } from './Body';

export default Body;
export type { BodyProps };
